'use strict'

import {createElements} from "../../functions";
import axios from "axios";
import {changeLangToCurrent} from "../language/langSwitcher";
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import {settingsData} from "../../settings";
import { contactToAgentWithWidget } from '../chats/chats';
import { setCookie } from '../cookies/setAndGetCookies';

export const initForm = async (parent) => {
    if (!config.general.leadForm && !settingsData.isConferenceHost) return;

    const formId = config.general.leadFormId;
    const url = `${config.apiDomain}/External/Interfaces/form/${formId}/`;

    // const url = `HTTPS://mbeat.bmby.com/External/Interfaces/form/${formId}/`;
    // const cssLink = `<link rel="stylesheet" type="text/css" href="https://yui.yahooapis.com/3.18.1/build/cssreset-context/cssreset-context-min.css">`;
    // document.querySelector('head').insertAdjacentHTML('beforeend', cssLink);

    const container = createElements('div', ['form__container-main'], parent, 'beforeend', {
        data: 'id',
        value: "interface-embbed"
    });

    await axios.post(url)
        .then(res => {
            container.innerHTML = res.data;
        })
        .catch(err => {
            console.log(err)
        });

    const scripts = container.querySelectorAll("script");
    const regExp = /google/gi;

    scripts.forEach(script => {
        const isGoogle = regExp.test(script.src);
        if (!isGoogle) {
            const s = document.createElement("script");
            s.setAttribute("type", "text/javascript");
            s.innerHTML = script.innerHTML;
            if (script.src && script.src !== "") {
                s.src = script.src;
            }
            container.insertAdjacentElement('beforeend', s);
        }
    });

    if (container.childNodes.length !== 0) {

        const isUS = config.apiDomain.match(/us/gi);
        // const script = `<script type="text/javascript" src="https://us.bmby.com/ext/intl-tel-input/build/js/intlTelInput.js"></script><link rel="stylesheet" href="https://us.bmby.com/ext/intl-tel-input/build/css/intlTelInput.css">`

        if (isUS) {
            window.intlTelInput = intlTelInput;
            // container.insertAdjacentHTML('afterbegin', script);
        }
    }

    addTitle(container);

    const style = container.querySelector('style');
    container.removeChild(style);
    customiseForm(container);

    return container;
}

export const customiseForm = (parent) => {
    const buttonList = parent.querySelectorAll('input[type=button]');
    buttonList.forEach(btn => {
        btn.classList.contains('button') && btn.classList.add('button');
        btn.removeAttribute('onclick');
        btn.addEventListener('click', handleFormClick);
    });

    const emailInput = parent.querySelector('input[type=email]');
    emailInput.removeAttribute('placeholder');
    emailInput.parentElement.classList.remove('hidden');
    changePhonePattern(parent);
    changePlaceholder(parent);
    setTranslateToCheckbox(parent);
    setTranslateToSendBtn(parent);
}

function changePhonePattern (parent) {
    const phoneInput = parent.querySelector('input[name="FieldData[Phone_Mobile]"]');

    if (!phoneInput) return;

    phoneInput.setAttribute('pattern','(^\\+?([0-9]{7,})$)');
}

const validateForm = () => {
    let valid = true;
    let formData = document.forms.namedItem("interfaceForm");
    if (formData == null) {
        const noForm = true;
        const wrapper = document.createElement('form');
        wrapper.name = "interfaceForm";
        const el = document.getElementById('bmbyFormWarp');
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
        formData = document.forms.namedItem("interfaceForm");
    }
    formData = formData.elements;
    valid = document.querySelector('form').reportValidity();

    for (let i = 0; i < formData.length; i++) {
        if (!formData[i].checkValidity()) valid = false;
    }

    return valid;
}

// const handleFormClick = (e) => {
//     const bmbyDomain = config.apiDomain === "https://mbeat.bmby.com" ? "https://bmby.com" : "https://wwwus.bmby.com";
//     let formData = document.forms.namedItem("interfaceForm");
//     let noForm;
//
//     if (formData == null) {
//          noForm = true;
//     }
//
//     if(validateForm()){
//         stamfunction();//builds hidden input - analytics
//         updateMediaData();//builds hidden input - MediaData
//         const oData = new FormData(formData);
//         oData.append("action", "sendform");
//
//
//         const url = bmbyDomain + "/shared/AddLead/index.php";
//         axios.post(url, oData)
//             .then(data => {
//                 if (data.request.readyState === 4 && data.status === 200) {
//                     const response = data.request.responseText && JSON.parse(data.request.responseText);
//                     if (response["status"] === "success") {
//                         switch (response["responseType"]) {
//                             case "redirect" :
//
//                                 window.location.href = response["response"];
//                                 break;
//
//                             case "alert" :
//                                 alert(response["response"]);
//                                 break;
//
//                             case "msg" :
//                                 const form = document.querySelector("#interface-embbed form");
//                                 const inform = document.querySelector("#messagerResponse");
//
//                                 inform.classList.add('language-string');
//                                 inform.setAttribute('data-dictionary', 'Thank you for your request, our agents will contact you soon');
//                                 inform.innerHTML = changeLangToCurrent('Thank you for your request, our agents will contact you soon');
//
//                                 form.style.display = "none";
//                                 // inform.innerHTML=response["response"];
//                                 inform.style.display = "block";
//
//                                 setTimeout(function () {
//                                     form.reset();
//                                     inform.style.display = "none";
//                                     form.style.display = "block";
//                                 }, 7000);
//
//                                 break;
//                         }
//                     } else {
//                         const alertbox = document.querySelector("#interface-embbed .alert-box");
//                         const errbox = document.querySelector("#interface-embbed .alert-box .error");
//                         alertbox.style.display = "block";
//                         errbox.style.display = "block";
//                         const inform = document.querySelector("#messagerResponse");
//                         inform.classList.add('language-string');
//                         inform.setAttribute('data-dictionary', 'Thank you for your request. Our agents will contact you soon');
//                         inform.innerHTML = changeLangToCurrent('Thank you for your request. Our agents will contact you soon');
//                         // inform.innerHTML = 'Thank you for your request. Our agents will contact you soon';
//                         // inform.innerHTML=response["response"];
//                         setTimeout(function () {
//                             alertbox.style.display = "none";
//                             errbox.style.display = "none";
//                         }, 3000);
//                     }
//
//                 } else
//                     alert("error");
//
//             })
//             .catch(err => console.log(err))
//     }
//     if(noForm){
//         noForm = false;
//         document.getElementById("bmbyFormWarp").outerHTML = document.getElementById("bmbyFormWarp").innerHTML;
//     }
// }


const handleFormClick = (e) => {
    const bmbyDomain = config.apiDomain === "https://mbeat.bmby.com" ? "https://bmby.com" : "https://wwwus.bmby.com";
    let formData = document.forms.namedItem("interfaceForm");
    let noForm;

    if (formData == null) {
        noForm = true;
    }

    if(validateForm()){
        stamfunction();//builds hidden input - analytics
        updateMediaData();//builds hidden input - MediaData
        const oData = new FormData(formData);
        oData.append("action", "sendform");


        const url = bmbyDomain + "/shared/AddLead/index.php";

        if (settingsData.isConferenceHost){

            setCookie('contactFormData',JSON.stringify({
                name: oData.get('FieldData[Fname]'),
                phone: oData.get('FieldData[Phone_Mobile]')
            }));

            setCookie('contactFormSend',Date.now());

            contactToAgentWithWidget();

            // const form = document.querySelector("#interface-embbed form");
            // const inform = document.querySelector("#messagerResponse");
            // const title = document.querySelector('.form__container-main_title');

            // inform.classList.add('language-string');
            // inform.setAttribute('data-dictionary', 'Thank you for your request, our agents will contact you soon');
            // inform.innerHTML = changeLangToCurrent('Thank you for your request, our agents will contact you soon');
            //
            // form.style.display = "none";
            // title.style.display = 'none';
            // // inform.innerHTML=response["response"];
            // inform.style.display = "block";
            //
            // setTimeout(function () {
            //     form.reset();
            //     inform.style.display = "none";
            //     form.style.display = "block";
            //     title.style.display = '';
            //     updateContactWidget();
            // }, 7000);

        } else {

            axios.post(url, oData)
                .then(data => {
                    if (data.request.readyState === 4 && data.status === 200) {
                        const response = data.request.responseText && JSON.parse(data.request.responseText);
                        if (response["status"] === "success") {

                            setCookie('contactFormData',JSON.stringify({
                                name: oData.get('FieldData[Fname]'),
                                phone: oData.get('FieldData[Phone_Mobile]')
                            }));

                            setCookie('contactFormSend',Date.now());

                            switch (response["responseType"]) {
                                case "redirect" :

                                    window.location.href = response["response"];
                                    break;

                                case "alert" :
                                    alert(response["response"]);
                                    break;

                                case "msg" :
                                    // const form = document.querySelector("#interface-embbed form");
                                    // const inform = document.querySelector("#messagerResponse");
                                    // const title = document.querySelector('.form__container-main_title');
                                    //
                                    // inform.classList.add('language-string');
                                    // inform.setAttribute('data-dictionary', 'Thank you for your request, our agents will contact you soon');
                                    // inform.innerHTML = changeLangToCurrent('Thank you for your request, our agents will contact you soon');
                                    //
                                    // form.style.display = "none";
                                    // title.style.display = 'none';
                                    // // inform.innerHTML=response["response"];
                                    // inform.style.display = "block";
                                    //
                                    // setTimeout(function () {
                                    //     form.reset();
                                    //     inform.style.display = "none";
                                    //     form.style.display = "block";
                                    //     title.style.display = '';
                                    //     updateContactWidget();
                                    // }, 7000);

                                    contactToAgentWithWidget();

                                    break;
                            }
                        } else {
                            const alertbox = document.querySelector("#interface-embbed .alert-box");
                            const errbox = document.querySelector("#interface-embbed .alert-box .error");
                            alertbox.style.display = "block";
                            errbox.style.display = "block";
                            const inform = document.querySelector("#messagerResponse");
                            inform.classList.add('language-string');
                            inform.setAttribute('data-dictionary', 'Thank you for your request. Our agents will contact you soon');
                            inform.innerHTML = changeLangToCurrent('Thank you for your request. Our agents will contact you soon');
                            // inform.innerHTML = 'Thank you for your request. Our agents will contact you soon';
                            // inform.innerHTML=response["response"];
                            setTimeout(function () {
                                alertbox.style.display = "none";
                                errbox.style.display = "none";
                            }, 3000);
                        }

                    } else
                        alert("error");

                })
                .catch(err => console.log(err))

        }


    }
    if(noForm){
        noForm = false;
        document.getElementById("bmbyFormWarp").outerHTML = document.getElementById("bmbyFormWarp").innerHTML;
    }
};

export const changePlaceholder = (parent) => {

    const placeholderDic = [
        {
            name: 'text',
            value: `${changeLangToCurrent('Name')}`
        },
        {
            name: 'tel',
            value: `${changeLangToCurrent('Phone')}`
        },
        {
            name: 'email',
            value: `${changeLangToCurrent('Email')}`
        }
    ]
    const inputList = parent.querySelectorAll('.input');

    inputList.forEach(input => {
        input.removeAttribute('placeholder');
        const ph = placeholderDic.find(object => input.getAttribute('type') === object.name);
        input.setAttribute('placeholder', ph.value);
        input.setAttribute('data-dictionary', ph.value);
    });
}

export const addTitle = (parent) => {
    const title = createElements('div', ['form__container-main_title', 'language-string'], parent, 'afterbegin');

    title.setAttribute('data-dictionary', 'leadFormTitle');
    title.innerHTML = `${changeLangToCurrent('leadFormTitle')}`;
}

export const setTranslateToSendBtn = (parent) => {
    const button = parent.querySelector('.button');
    if (!button) return;

    button.classList.add('language-string');
    button.setAttribute('data-dictionary', 'send');

    const flexibleInputDictionaryAttribute = button.getAttribute('data-dictionary');
    button.setAttribute('value', `${changeLangToCurrent(flexibleInputDictionaryAttribute)}`);
}

export const setPropId = (parent, object) => {
    const inputList = parent.querySelectorAll(`input[name="FieldData[PropID]"]`);

    inputList.forEach(element => {
        element.value = object.userData.crm_data.bmbyPropID;
    })
}

export const setTranslateToCheckbox = (parent) => {
    const checkBox = parent.querySelector('input[name="FieldData[MailSms]"]');
    const checkBoxParent = checkBox.parentElement;
    const textElement = checkBoxParent.querySelector('span');

    checkBoxParent.classList.add('mail-sms-field');
    textElement.classList.add('language-string');
    textElement.setAttribute('data-dictionary', 'I would like to receive marketing information, special offers and benefits through email and sms');
    textElement.innerHTML = changeLangToCurrent('I would like to receive marketing information, special offers and benefits through email and sms');
}

export const moveFormToBlock = (parent = document.body, position = 'beforeend') => {
    if (!config.general.leadForm && !settingsData.isConferenceHost)  return;

    const form = document.querySelector('.form__container-main');
    parent.insertAdjacentElement(position, form);
}
